// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AjimOMAyabg5yNhxfn71{padding:11px 20px 24px}.S974OkkdlA8_0YHBECDS{padding-bottom:24px;padding-right:8px}.JBFxZUBGD4qRlA6ncP2A{align-items:center;gap:12px;display:flex}.cfx50d_Q3IEE5ogkXmNT{align-items:center;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `AjimOMAyabg5yNhxfn71`,
	"settings": `S974OkkdlA8_0YHBECDS`,
	"recordControls": `JBFxZUBGD4qRlA6ncP2A`,
	"controlsLeft": `cfx50d_Q3IEE5ogkXmNT`
};
export default ___CSS_LOADER_EXPORT___;
